import React from "react"
import CountryDropdownButton from "./options/CountryDropdownButton"
import { countryCurrencies } from "@staticdata/currencies"

const CurrencySelector = () => {
	
	return (
		<React.Fragment>
			<div className="block">
				<CountryDropdownButton
					className='text-black lg:text-white border-0 py-1.5 w-auto'
					optionListWidth={'w-96'}
					defaultOption={countryCurrencies[0]}
					options={countryCurrencies}
					noShadows
				/>
			</div>
		</React.Fragment>
	)
}

export default CurrencySelector